import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { StandaloneServiceBooking } from '../../models';
import { ApiService } from '../../utils/api.service';

@Injectable()
export class StandaloneServiceBookingService {

  path = 'standalone_service_bookings';
  constructor(
    private api: ApiService,
  ) {
  }

  save(standaloneServiceBooking): Observable<StandaloneServiceBooking> {
    if (standaloneServiceBooking.id) {
      return this.api.put(`${this.path}/${standaloneServiceBooking.id}`, standaloneServiceBooking);
    } else {
      return this.api.post(this.path, standaloneServiceBooking);
    }
  }
}
